import UserRepository from "@domain/repositories/UserRepository";
import UseCase from "@domain/UseCase";
import { ImageFile } from "@domain/models/ImageFile";
import { User } from "@domain/models/User";

type Input = {
  data: Partial<User>;
  userImage?: ImageFile;
};

type Output = Promise<User>;

export class CreateUserUseCase implements UseCase<Input, Output> {
  constructor(private readonly userRepository: UserRepository) {}

  execute({ data, userImage }: Input) {
    return this.userRepository.create(data, userImage);
  }
}
